/* eslint-disable */
import { Util } from '@libs/utilities/util';
import { EnumNgPointerType, INgCustomStepDefinition, TypeNgCombineLabelsFunction, TypeNgGetLegendFunction, TypeNgGetStepLegendFunction, TypeNgPositionToValueFunction, TypeNgTranslateFunction, TypeNgValueToPositionFunction } from './customizable-slider.interface';


/**------------------------------------------------------
 * Slider Options
 */
export class NgCustomizableSliderOptions {
	floor					?: number 	= 0;
	ceil					?: number 	= null!;
	step					?: number 	= 1;
	minRange				?: number 	= null!;
	maxRange				?: number 	= null!;
	pushRange				?: boolean 	= false;
	minLimit				?: number 	= null!;
	maxLimit				?: number 	= null!;
	translate				?: TypeNgTranslateFunction = null!;
	combineLabels			?: TypeNgCombineLabelsFunction = null!;
	getLegend				?: TypeNgGetLegendFunction = null!;
	getStepLegend			?: TypeNgGetStepLegendFunction = null!;
	stepsArray				?: INgCustomStepDefinition[] = null!;
	bindIndexForStepsArray	?: boolean 	= false;
	draggableRange			?: boolean 	= false;
	draggableRangeOnly		?: boolean 	= false;
	showSelectionBar		?: boolean 	= false;
	showSelectionBarEnd		?: boolean 	= false;
	showSelectionBarFromValue ?: number	= null!;
	showOuterSelectionBars	?: boolean 	= false;
	hidePointerLabels		?: boolean 	= false;
	hideLimitLabels			?: boolean 	= false;
	autoHideLimitLabels		?: boolean 	= true;
	readOnly				?: boolean 	= false;
	disabled				?: boolean 	= false;
	showTicks				?: boolean 	= false;
	showTicksValues			?: boolean 	= false;
	tickStep				?: number 	= null!;
	tickValueStep			?: number 	= null!;
	ticksArray				?: number[] = null!;
	ticksTooltip			?: (value: number) => string = null!;
	ticksValuesTooltip		?: (value: number) => string = null!;
	vertical				?: boolean = false;
	getSelectionBarColor	?: (minValue: number, maxValue?: number) => string = null!;
	getTickColor			?: (value: number) => string = null!;
	getPointerColor			?: (value: number, pointerType: EnumNgPointerType) => string = null!;
	keyboardSupport			?: boolean 	= true;
	scale					?: number 	= 1;
	rotate					?: number 	= 0;
	enforceStep				?: boolean 	= true;
	enforceRange			?: boolean 	= true;
	enforceStepsArray		?: boolean 	= true;
	noSwitching				?: boolean 	= false;
	onlyBindHandles			?: boolean 	= false;
	rightToLeft				?: boolean 	= false;
	reversedControls		?: boolean 	= false;
	boundPointerLabels		?: boolean 	= true;
	logScale				?: boolean 	= false;
	customValueToPosition	?: TypeNgValueToPositionFunction = null!;
	customPositionToValue	?: TypeNgPositionToValueFunction = null!;
	precisionLimit			?: number 	= 12;
	selectionBarGradient	?: { from: string, to: string } = null!;
	ariaLabel				?: string 	= 'customizable-slider';
	ariaLabelledBy			?: string 	= null!;
	ariaLabelHigh			?: string 	= 'customizable-slider-max';
	ariaLabelledByHigh		?: string 	= null!;
	handleDimension			?: number 	= null!;
	barDimension			?: number 	= null!;
	animate					?: boolean 	= true;
	animateOnMove			?: boolean 	= false;
}


/**------------------------------------------------------
 * Helper Data Classes
 */
export class NgTick {
	style				 	: object 	= {};
	value				 	: string 	= null!;
	legend				 	: string 	= null!;
	tooltip				 	: string 	= null!;
	selected			 	: boolean 	= false;
	valueTooltip		 	: string 	= null!;
	tooltipPlacement	 	: string 	= null!;
	valueTooltipPlacement	: string 	= null!;
}

export class NgDragging {
	active			: boolean = false;
	value			: number  = 0;
	difference		: number  = 0;
	position		: number  = 0;
	lowLimit		: number  = 0;
	highLimit		: number  = 0;
}

export class NgModelValues {
	value		!: number;
	highValue	!: number;

	static compare(x?: NgModelValues, y?: NgModelValues): boolean {

		//0 - check both undefined
		if (Util.Basic.isUndefined(x) && Util.Basic.isUndefined(y)) return false;

		//1 - check if unequal
		if (Util.Basic.isUndefined(x) !== Util.Basic.isUndefined(y)) return false;

		//2 - return the final status
		return (x!.value === y!.value && x!.highValue === y!.highValue);
	}
}

export class NgModelChange extends NgModelValues {
	forceChange!: boolean;
	static override compare(x?: NgModelChange, y?: NgModelChange): boolean {
		if (Util.Basic.isUndefined(x)  && Util.Basic.isUndefined(y)) return false;
		if (Util.Basic.isUndefined(x) !== Util.Basic.isUndefined(y)) return false;
		return (x!.value === y!.value && x!.highValue === y!.highValue && x!.forceChange === y!.forceChange);
	}
}

export class NgInputModelChange extends NgModelChange {
  	internalChange!: boolean;
}

export class NgOutputModelChange extends NgModelChange {
  	userEventInitiated!: boolean;
}

export class NgChangeContext {
	value	   !: number;
	highValue  ?: number;
	pointerType!: EnumNgPointerType;
}
